import { render, staticRenderFns } from "./detalle-tarifa.vue?vue&type=template&id=20b9e888&"
import script from "./detalle-tarifa.vue?vue&type=script&lang=js&"
export * from "./detalle-tarifa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports